import image from "assets/img/default/pie.png";
import CustomImage from "components/CustomImage";
import CustomTooltip from "components/CustomTooltip";
import React from "react";

export default function PieCard({
  data = {},
  onClick = () => {},
  dense = false,
}) {
  return (
    <CustomTooltip title={data?.description ?? ""} arrow>
      <div
        className={`
          w-32 ${dense ? "h-full" : "h-40"}
            relative
            rounded overflow-hidden
            cursor-pointer
            transition-all duration-300 hover:shadow-logo`}
        onClick={() => onClick(data)}
      >
        <CustomImage
          className="w-full object-contain overflow-hidden -mt-5"
          src={data?.image ?? image}
          ait={data?.name ?? ""}
          title={data?.name ?? ""}
        />
      </div>
    </CustomTooltip>
  );
}
